import * as React from 'react';
const PointerDownwardTriangle = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={8} fill="none" {...props}>
    <path fill="#000" fillOpacity={0.9} stroke="#000" d="M2 1h13L8.5 7 2 1Z" />
  </svg>
);
export default PointerDownwardTriangle;
